import { useCreateCruisePurchase } from 'api-hooks/order/cruise';
import { CruiseSaleModel } from 'api-hooks/sale/cruise';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import useApprovalableEdit from 'hooks/use-approvalable-edit';
import { SeparatorVertical } from 'legacy-modules/styles';
import * as React from 'react';
import { NavigationProps } from 'types';

import CruisePurchaseForm from './components/form';
import { CruisePurchaseFormType } from './components/form-type';

export type CruisePurchaseCreateParams = {
  cruiseSale?: CruiseSaleModel;
  defaultValues?: CruisePurchaseFormType;
};

export default function CruisePurchaseCreate(
  props: NavigationProps<NavigationRoutes.CruisePurchasesView>,
) {
  const { mutateAsync, error } = useCreateCruisePurchase();

  const onResolve = useApprovalableEdit('cruise-purchases');

  return (
    <>
      <CruisePurchaseForm
        {...props}
        cruiseSale={props.navigation.params?.cruiseSale}
        defaultValues={props.navigation.params?.defaultValues}
        renderError={
          !!error &&
          !!error.message && (
            <>
              <Notification
                overrides={{
                  Body: { style: { width: 'auto', wordBreak: 'break-all' } },
                }}
                kind={KIND.negative}
                closeable
              >
                {() => error.message}
              </Notification>
              <SeparatorVertical $margin={8} />
            </>
          )
        }
        onSubmit={async (input: any, form) => {
          const result = await mutateAsync(input);
          onResolve(result);
          return result.data;
        }}
      />
    </>
  );
}
